import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import {
  deleteManyProviderIn,
  deleteProviderIn,
  getProviderIns,
} from "store/provider-in/provider-in-action"
import ProviderInListComponent from "components/ProviderIn/list"
import SAlert from "components/Alert"
import {
  getProviderItemCategories,
  getProviderProjects,
} from "store/provider-dashboard/provider-dashboard-action"
import useSearch from "hooks/useSearch"
import ProviderInDetailModal from "components/ProviderIn/details"
import { getActivityLogs } from "store/activity-logs/activity-logs-action"
import ActivityLogsComponents from "components/ActivityLogs/ActivityLogs"

const ActivityLogsList = () => {
  document.title = "Activiy Logs"

  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(state => state.activityLogs)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getActivityLogs(link.url, pageNumber, according, search, advnacedSearch)
    )
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getActivityLogs(undefined, undefined, undefined, search, advnacedSearch),
    search
  )

  // get new activity logs at first time
  useEffect(() => {
    dispatch(
      getActivityLogs(undefined, pageNumber, according, search, advnacedSearch)
    )
  }, [pageNumber, according])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(getActivityLogs(undefined, undefined, undefined, search, data))
  }
  return (
    <React.Fragment>
      <Breadcrumbs title={"Admin"} breadcrumbItem={"Activity Logs"} />
      <ActivityLogsComponents
        data={data}
        error={error}
        loading={loading}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
      />
    </React.Fragment>
  )
}

export default ActivityLogsList
